import React from 'react';
// Firebase DB 
import { db } from '../firebase';
import { useDispatch } from "react-redux";

// import firebase from 'firebase/compat/app';
// import 'firebase/compat/auth';
// import 'firebase/compat/firestore';
// 
// css and ICONS 
import styled from 'styled-components';
import { enterRoom } from '../features/appSlice';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';



function SidebarOption({Icon,title,
  addChannelOption,id}) {
  const dispatch= useDispatch();


  const addChannel=()=>{
      const channelName= prompt ('Please enter the channel name');

      if(channelName){
        db.collection('rooms').add({
          name: channelName,
        });
      }
  };

  const selectChannel=()=>{
    if(id){
      dispatch(enterRoom({
        roomId:id,
      })
      );
    }
  };

  return (
   <SidebarOptionContainer
        onClick={addChannelOption ? addChannel: selectChannel}
   >
      {Icon && <Icon fontSize="small" style={{padding:10}} />}
     {Icon ? (
      <h3>{title}</h3>
      ):(
        <SidebarOptionChannel>
          <span><Groups2OutlinedIcon/></span> <h3>{title}</h3>
          
        </SidebarOptionChannel>
      
     )}
     
   </SidebarOptionContainer>
  );
}

export default SidebarOption ;


const SidebarOptionContainer = styled.div`
display: flex;
font-size: 12px;
align-items: center;
padding-left: 2px;
cursor: pointer;

:hover{
  opacity: 0.9;
  background-color:#4A5564;
}
`;

const SidebarOptionChannel = styled.div`
display: flex;
padding: 10px 10px; 


>h3{
  margin-top: 5px;
  font-weight: 400;
}
>span>.MuiSvgIcon-root{
  padding-right:10px;
}

`;


